import * as React from "react";
import { singleton } from "logic/singleton";
const WidgetContext = React.createContext(void 0);
export default singleton("contexts.WidgetContext", () => WidgetContext);
